import "./src/styles/global.css"
import { captureMarketingAttributionFromLocation } from "./src/utils/marketingAttribution"

export const onClientEntry = () => {
  captureMarketingAttributionFromLocation()
}
